import React, { useMemo } from 'react';

function AddProductButton({ updateProduct, buttonText, isProductAdded }) {
  const product = useMemo(
    () =>
      JSON.parse(document.querySelector('#add-product-button').dataset.product),
    []
  );

  const handleClick = async () => {
    let productColor;
    try {
      productColor = JSON.parse(
        document.querySelector('#add-product-button').dataset.productColor
      );
    } catch (error) {
      console.error('Error parsing productColor JSON:', error);
      productColor = null;
    }

    // If no specific color is selected (only has marketingImageUrl),
    // try to fetch the first available color
    if (!productColor || !productColor.id) {
      try {
        // Fetch product colors from the API
        const response = await fetch(`/products/${product.id}/colors`);
        if (response.ok) {
          const colors = await response.json();
          if (colors && colors.length > 0) {
            // Use the first available color
            productColor = {
              id: colors[0].id,
              name: colors[0].name,
              marketingImageUrl:
                colors[0].marketingImageUrl ||
                (productColor && productColor.marketingImageUrl),
              hexCode: colors[0].hexCode,
            };
          } else {
            // If no colors available, create a default color object
            productColor = {
              id: 'default',
              name: 'Default',
              marketingImageUrl:
                (productColor && productColor.marketingImageUrl) || '',
              hexCode: '#FFFFFF',
            };
          }
        }
      } catch (error) {
        console.error('Error fetching product colors:', error);
        // Fallback to a default color if API call fails
        productColor = {
          id: 'default',
          name: 'Default',
          marketingImageUrl:
            (productColor && productColor.marketingImageUrl) || '',
          hexCode: '#FFFFFF',
        };
      }
    }

    updateProduct(product, productColor);
  };

  return (
    <button
      onClick={handleClick}
      className={`button ${
        isProductAdded ? 'button--success' : 'button--alt'
      } button--full`}
    >
      {buttonText}
    </button>
  );
}

export default AddProductButton;
